import { TrademarkIcon } from './TrademarkIcon';

/**
 * author: Michael Irigoyen
 * id E1849947-175A-4347-BFC7-D8C7811F0B2B
 * name trademark
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/trademark.svg
 * tags
 */
export const TmIcon = TrademarkIcon;
export default TmIcon